import VueCharts from 'vue-chartjs';
import { Bar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

// #4A89E5 
// #45BFFC 
// #42E6F2 
// #3DF2C3 
// #7B90F2 
// #9BF9CA

export default Bar.extend({
    mixins: [reactiveProp],
    props: ["options"],
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})


// WEBPACK FOOTER //
// ./src/components/graphs/BarChart.js